import {
  checklistTemplateAdminListResponse,
  checklistTemplateAdminSummary,
  checklistTemplateAssetsResponse,
  type ChecklistTemplateAdminListResponse,
  type ChecklistTemplateAdminSummary,
  type ChecklistTemplateAssetsResponse,
  type ChecklistTemplateUpdateBody,
} from "@bitacorapro/api-types";
import { request } from "../client";

// The admin "checklists por tienda" configuration surface (ADR-0079).
// The per-store picker (GET /assets/:assetId/checklist-templates), the
// "ver detalle" structure viewer, and "marcar revisado" moved to
// maintenance-items (ADR-0083) and were retired from this API — see
// endpoints/maintenance.ts for their replacements.
export const checklistTemplatesApi = {
  // GET /checklist-templates — admin list, org-scoped, incl. archived
  // (ADR-0079). Feeds the "asignar checklists a tiendas" admin screen.
  listAdmin: async (): Promise<ChecklistTemplateAdminListResponse> => {
    const json = await request<unknown>("GET", "core", "/checklist-templates");
    return checklistTemplateAdminListResponse.parse(json);
  },
  // GET /checklist-templates/:templateId/assets — which stores carry
  // this template. Feeds the admin template-detail view.
  getAssets: async (templateId: string): Promise<ChecklistTemplateAssetsResponse> => {
    const json = await request<unknown>("GET", "core", `/checklist-templates/${templateId}/assets`);
    return checklistTemplateAssetsResponse.parse(json);
  },
  // PUT /checklist-templates/:templateId/assets — full replace of the
  // assignment set (ADR-0079 Decision 5). Idempotent by verb.
  putAssets: async (
    templateId: string,
    body: { assetIds: string[] }
  ): Promise<ChecklistTemplateAssetsResponse> => {
    const json = await request<unknown>(
      "PUT",
      "core",
      `/checklist-templates/${templateId}/assets`,
      { body }
    );
    return checklistTemplateAssetsResponse.parse(json);
  },
  // PATCH /checklist-templates/:templateId — label / cadenceDays /
  // displayOrder / active / scope, plus the co-transactional `assetIds`
  // a brand -> assets scope flip requires (ADR-0079). Body shape is
  // ChecklistTemplateUpdateBody straight from the wire schema, not a
  // hand-rolled subset, so a field added to the backend's partial-update
  // body doesn't silently go unsent here.
  patch: async (
    templateId: string,
    body: ChecklistTemplateUpdateBody
  ): Promise<ChecklistTemplateAdminSummary> => {
    const json = await request<unknown>("PATCH", "core", `/checklist-templates/${templateId}`, {
      body,
    });
    return checklistTemplateAdminSummary.parse(json);
  },
};
